import { UPSELL_LINKS } from './site'

export interface Upsell {
  name: string
  kicker: string
  body: string
  highlights: string[]
  image: string
  href: string
}

export const upsells: Upsell[] = [
  {
    name: 'Deco Resina Botánica',
    kicker: 'Nivel 2 · Volumen y brillo',
    body: 'En esta guía aprendés a transformar flores reales en piezas de resina con acabado profesional, ideales para crear accesorios, objetos decorativos y productos artesanales de alto valor visual y comercial.',
    highlights: ['Joyería y llaveros', 'Objetos decorativos', 'Acabado profesional'],
    image:
      'https://cdn.magicpatterns.com/uploads/s8VQhGHkYKGi9W7wPcQvRz/RESINA_BOTANICA.png',
    href: UPSELL_LINKS.resina,
  },
  {
    name: 'Deco Bordado Botánico',
    kicker: 'Nivel 2 · Textura y detalle',
    body: 'Aprendé a integrar flores reales en composiciones bordadas delicadas y originales para crear piezas decorativas únicas, regalos especiales y productos artesanales listos para ofrecer o vender.',
    highlights: ['Bastidores decorativos', 'Regalos especiales', 'Piezas de autor'],
    image:
      'https://cdn.magicpatterns.com/uploads/hN1gTnYgiYGYjizX13wF5Q/BORDADO_BOTANICO.png',
    href: UPSELL_LINKS.bordado,
  },
]
